import React, {useEffect} from 'react';
import {useState} from "react";
import './Login.css';
import {Error} from '../../components/Error/Error'
import {Logo} from '../../components/Logo/Logo'
import { sha256 } from 'js-sha256';
import {useSearchParams} from "react-router-dom";
import LoginForm from './LoginForm/LoginForm'
import ResetPassword from './ResetPassword/ResetPassword'

const Login = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const [loginAttempt, setLoginAttempt] = useState(false);
    const [resetPassword, setResetPassword] = useState(false);

    useEffect(() => {
        if (searchParams.get("login") && searchParams.get("login") === "failed")
            setLoginAttempt(true);

        if (searchParams.get("invalid_user")) {
            setResetPassword(true);
            setLoginAttempt(true);
        }

        if (searchParams.get('reset_pass')) {
            setResetPassword(true);
        }
    }, [])

    let loginAttemptStatus = (<div></div>);
    let formDataShow = (!resetPassword) ? (<LoginForm resetPassword={setResetPassword}/>) : (<ResetPassword resetPassword={setResetPassword}/>);

    if (loginAttempt) {
        loginAttemptStatus = (resetPassword) ? <Error strongText={"Invalid User:"} text={"Something was wrong with your credentials."}/> : <Error strongText={"Failed Login:"} text={"Something was wrong with your login credentials."}/>
    }


    return (
        <div className="">
            <div className="flex h-screen items-center justify-center">
                <div className="w-full max-w-lg space-y-8 px-4">
                    {/*<div className="p-12 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">*/}

                        <Logo alt={"Ameego Logo"} />

                        {loginAttemptStatus}

                        {formDataShow}

                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
}

export default Login;
